import React from 'react';

class Injecter {
  static injectBodyScript({
    url,
    body,
    async,
    type = "text/javascript",
    tag
  }) {
    if (!window || !window.document) {
      throw new Error("Injecter.injectBodyScript: window or window.document is not defined");
    }
    if (tag && document.querySelector(`script[data-tag="${tag}"]`)) {
      return;
    }
    const script = document.createElement("script");
    if (url) {
      script.src = url;
    }
    if (async) {
      script.async = true;
    }
    if (body) {
      script.innerHTML = body;
    }
    if (type) {
      script.type = "text/javascript";
    }
    if (tag) {
      script.setAttribute("data-tag", tag);
    }
    document.body.appendChild(script);
  }
}

class HelpscoutBeacon extends React.PureComponent {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    const id = this.props.id || "";
    Injecter.injectBodyScript({
      body: `!function(e,t,n){function a(){var e=t.getElementsByTagName("script")[0],n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://beacon-v2.helpscout.net",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],"complete"===t.readyState)return a();e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)}(window,document,window.Beacon||function(){});`,
      tag: "helpscout-beacon-core"
    });
    Injecter.injectBodyScript({
      body: `window.Beacon('init', '${id}')`,
      tag: "helpscout-beacon-init"
    });
  }
  render() {
    return null;
  }
}

class Helpscout {
  static inject(id) {
    Injecter.injectBodyScript({
      body: `!function(e,t,n){function a(){var e=t.getElementsByTagName("script")[0],n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://beacon-v2.helpscout.net",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],"complete"===t.readyState)return a();e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)}(window,document,window.Beacon||function(){});`,
      tag: "helpscout-beacon-core"
    });
    Injecter.injectBodyScript({
      body: `window.Beacon('init', '${id}')`,
      tag: "helpscout-beacon-init"
    });
  }
}

export { Helpscout, HelpscoutBeacon, Injecter, HelpscoutBeacon as default };
//# sourceMappingURL=index.esm.js.map
